/* PackageExplorerLmrbComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageExplorerLmrbRenderer");
const _ = require("lodash");
const Registrations = require("../../../RegistrationNamespaces");

const Steve = require("@gluenetworks/steve_core").getInstance();
const MagicBusAddon = require("../../addons/MagicBus/MagicBusAddon");
Steve.addOn("MagicBus", MagicBusAddon, {addOnMode: true});

class PackageExplorerLmrbComponent extends EventEmitter {
    constructor(
        userSession,
        logger,
        editorLayout,
        HubbyService,
        userFeedback,
        magicBus,
        solutionManager,
        steveIO,
        di
    ) {
        super(di);
        this._logger = logger;
        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._userFeedback = userFeedback;
        this._magicBus = magicBus;
        this._fileFactory = steveIO.fileFactory;

        this._di = di;
        this._distCenterStatus = undefined;

        this._solutionManager = solutionManager;

        this._hubbyService = HubbyService;

        //Available Packages
        this.setAvailablePackages({}, true);

        //Error
        this.setError(undefined);

        //Loading
        this._loadingPromise = undefined;

        //Filter Information
        this._filterDetails = {
            installedOnly: false,
            filterString: "",
        };

        this._registerListeners();

        this._distCenterStatus = this._initStatusBar();

        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        this._userSession.on(
            "OrganizationChange",
            (this._onActiveOrganizationChanged = this._onActiveOrganizationChanged.bind(this))
        );
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        //TODO HACK ALERT
        this._magicBus.on(
            "PackageInstalled",
            (this._onPackageInstalled = this._onPackageInstalled.bind(this))
        );
    }
    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onActiveOrganizationChanged);
        this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        //TODO HACK Alert
        this._magicBus.removeListener("PackageInstalled", this._onPackageInstalled);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._filterDetails = undefined;
            this._loadingPromise = undefined;
            this._availablePackages = undefined;
            this._steve = undefined;
            this._logger = undefined;
            this._hubbyService = undefined;
            this._solutionManager = undefined;
            this._magicBus = undefined;
            resolve();
        });

        this._distCenterStatus.shutdown();

        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START LMRB API METHODS */
    /*******************************************/
    onContainerSizeChange(sizes) {
        this.emit("LmrbResizeEvent", sizes);
    }
    /*******************************************/
    /* END LMRB API METHODS */
    /* START HANDLER METHODS */
    /******************************************/
    _onSolutionChanged(/*newActiveSolution*/) {
        // Case 22070 -- removing the condition and shutting down always
        // if (
        //     !newActiveSolution.lmrbNamespaces ||
        //     !newActiveSolution.lmrbNamespaces.includes(Registrations.PACKAGE_EXPLORER_LMRB)
        // ) {
        this.shutdown();
        // }
    }
    _onActiveOrganizationChanged(activeOrganization) {
        this.filterString = "";
        this.loadAvailablePackages(activeOrganization.id);
    }
    _onPackageInstalled() {
        this._open();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _repoGetAllAvailablePackages(orgId) {
        return new Promise((resolve, reject) => {
            this._hubbyService.repoGetAllAvailablePackages(
                {orgId},
                {
                    Success: (availablePackages) => resolve(availablePackages),
                    Failure: (error) => {
                        //No recovery at this point
                        this.setError(error.error);
                        this.logger.warn(
                            {repoGetAllError: error},
                            `Failed to retrieve all available packages for org ${orgId}`
                        );
                        reject(error);
                    },
                }
            );
        });
    }

    _open() {
        let orgId = _.get(this._userSession, "activeOrganization.id");
        if (orgId) {
            return this.loadAvailablePackages(orgId);
        } else {
            return Promise.resolve();
        }
    }

    _initStatusBar() {
        this._defaultDiOpts = {
            defaultInjectables: ["$teve.logger", "eventEmitter.eventEmitter"],
        };
        let diOpts = _.cloneDeep(this._defaultDiOpts) || {};
        diOpts.injectableOverrides = {
            //"gameEditor.gameEditor": this,
            "eventEmitter.eventEmitter": this,
        };
        return this._di.createInstance(Registrations.PACKAGE_EXPLORER_STATUS_BAR, diOpts);
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get filterString() {
        return this.getFilterString();
    }
    getFilterString() {
        return _.get(this._filterDetails, "filterString", "");
    }
    set filterString(fltrStr) {
        return this.setFilterString(fltrStr);
    }
    setFilterString(fltrStr) {
        let old = _.cloneDeep(this.filterString);
        _.set(this._filterDetails, "filterString", fltrStr || "");
        if (!_.isEqual(old, this.filterString)) {
            this.emit("FilterStringChanged", this.filterString, old);
        }

        return this;
    }
    get filterInstalledOnly() {
        return this.getFilterInstalledOnly();
    }
    getFilterInstalledOnly() {
        return _.get(this._filterDetails, "installedOnly", false);
    }
    set filterInstalledOnly(installedOnly) {
        return this.setFilterInstalledOnly(installedOnly);
    }
    setFilterInstalledOnly(installedOnly) {
        let old = _.cloneDeep(this.filterInstalledOnly);
        _.set(this._filterDetails, "installedOnly", installedOnly || false);
        if (!_.isEqual(old, this.filterInstalledOnly)) {
            this.emit("FilterInstalledOnlyChanged", this.filterInstalledOnly, old);
        }
        return this;
    }
    get filteredPackages() {
        return this.getFilteredPackages();
    }
    getFilteredPackages() {
        let filteredPackages = {};
        //Loop through all the Repos with available packages
        Object.keys(this.availablePackages).forEach((repoId) => {
            let repoSummary = this.availablePackages[repoId];
            switch (_.get(repoSummary, "repository.type")) {
                case "DC":
                case "FS":
                case "DB":
                    repoSummary.packages.forEach((pkgSummary) => {
                        //we are only showing installed packages
                        if (
                            this.getFilterInstalledOnly() &&
                            (_.get(pkgSummary, "diff") === "RemoteOnly" || repoId !== "latest")
                        ) {
                            //don't include this package
                            return;
                        }
                        //we are only showing available packages
                        if (
                            !this.getFilterInstalledOnly() &&
                            _.get(pkgSummary, "diff") === "LocalOnly"
                        ) {
                            //don't include this package
                            return;
                        }
                        //If we are filtering by name
                        let filterString = this.getFilterString();
                        if (filterString) {
                            //First looking for the name in the "local" prop then remote just in case
                            let pkgName = _.get(
                                pkgSummary,
                                "local.name",
                                _.get(pkgSummary, "remote.name")
                            );
                            //name doesn't start with the filterString
                            if (!pkgName.toLowerCase().includes(filterString.toLowerCase())) {
                                //don't include this package
                                return;
                            }
                        }
                        //This package is not being filtered out so add it
                        //repository object now created explicitly to avoid "by reference" issue
                        if (
                            _.get(pkgSummary, "remote.repoName") ||
                            _.get(pkgSummary, "local.repoName")
                        ) {
                            if (!filteredPackages.git) {
                                filteredPackages.git = {
                                    repository: {
                                        type: repoSummary.repository.type,
                                        name: repoSummary.repository.name,
                                    },
                                    packages: [],
                                };
                            }
                            filteredPackages.git.packages.push(pkgSummary);
                        }
                        //else add as normal
                        else {
                            if (!filteredPackages[repoId]) {
                                filteredPackages[repoId] = {
                                    repository: {
                                        type: repoSummary.repository.type,
                                        name: repoSummary.repository.name,
                                    },
                                    packages: [],
                                };
                            }
                            filteredPackages[repoId].packages.push(pkgSummary);
                        }
                    });
                    break;
                default:
                    //TODO add HG support
                    this.logger.warn(
                        {repoSummary: repoSummary},
                        `Currently we only support Distribution Center Repos. Ignoring (${_.get(
                            repoSummary,
                            "repository.name"
                        )})...`
                    );
                    break;
            }
        });
        if (filteredPackages && filteredPackages.latest) {
            _.set(
                filteredPackages,
                ["latest", "repository", "name"],
                this.getFilterInstalledOnly() ? "Installed Releases" : "Latest Releases"
            );
            _.set(
                filteredPackages,
                ["latest", "repository", "description"],
                this.getFilterInstalledOnly()
                    ? "Packages that are currently installed"
                    : "The latest packages that are available for installation"
            );
        }
        if (filteredPackages && filteredPackages.prev) {
            _.set(filteredPackages, ["prev", "repository", "name"], "Other Releases Available");
            _.set(
                filteredPackages,
                ["prev", "repository", "description"],
                "Other versions of packages that are available for installation"
            );
        }
        if (filteredPackages && filteredPackages.git) {
            _.set(filteredPackages, ["git", "repository", "name"], "Repositories");
            _.set(filteredPackages, ["git", "repository", "description"], "Git Repositories");
        }
        return filteredPackages;
    }
    get userFeedback() {
        return this._userFeedback;
    }
    get logger() {
        return this._logger;
    }
    set availablePackages(aPkgs) {
        return this.setAvailablePackages(aPkgs);
    }
    setAvailablePackages(aPkgs, silent) {
        let old = _.cloneDeep(this._availablePackages),
            orderedPackages = [],
            sortedPackages = {};
        for (let pkg in aPkgs) {
            orderedPackages.push({
                id: pkg,
                name: _.get(aPkgs[pkg], "repository.name", ""),
            });
        }
        orderedPackages.sort((aPkg, bPkg) => {
            let aPackageName = aPkg.name,
                bPackageName = bPkg.name;
            return aPackageName.localeCompare(bPackageName, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        });
        orderedPackages.forEach((pkg) => {
            if (_.isArray(aPkgs[pkg.id].packages)) {
                sortedPackages[pkg.id] = aPkgs[pkg.id];
                sortedPackages[pkg.id].packages.sort((aPkg, bPkg) => {
                    let aPackageName = _.get(aPkg, "local.name", _.get(aPkg, "remote.name")),
                        bPackageName = _.get(bPkg, "local.name", _.get(bPkg, "remote.name"));
                    return aPackageName.localeCompare(bPackageName, undefined, {
                        numeric: true,
                        sensitivity: "base",
                    });
                });
            }
        });
        this._availablePackages = sortedPackages;
        if (!silent) {
            this.emit("AvailablePackagesReplaced", this._availablePackages, old);
        }
        return this;
    }
    get availablePackages() {
        return this.getAvailablePackages();
    }
    getAvailablePackages() {
        return this._availablePackages;
    }
    getPackageByRemoteId(pkgId) {
        let foundPkg;
        Object.keys(this._availablePackages).every((repoId) => {
            let repo = this._availablePackages[repoId];
            _.get(repo, "packages", []).every((reposPkg) => {
                if (pkgId === _.get(reposPkg, "remote.pkgId")) {
                    foundPkg = reposPkg;
                    return false;
                }
                return true;
            });
            if (foundPkg) {
                return false;
            }
            return true;
        });
        return foundPkg;
    }
    updatePackage(pkg) {
        let foundPkg = this.getPackageByRemoteId(_.get(pkg.remote, "pkgId"));
        let old = _.cloneDeep(foundPkg);

        if (foundPkg) {
            foundPkg.local = foundPkg.remote;
            foundPkg.diff = "Same";
            this.emit("PackageUpdated", foundPkg, old);
        }
    }
    loadAvailablePackages(orgId) {
        if (!orgId) {
            return Promise.reject("No orgId");
        }

        this._loadingPromise = Promise.resolve()
            .then(() => this.userFeedback.hideDisplayed())
            .then(() => this.userFeedback.displayLoading())
            .then(() => this._repoGetAllAvailablePackages(orgId))
            .then((availablePackages) => {
                this.userFeedback.hideDisplayed();
                this.setAvailablePackages(availablePackages);
            })
            .catch((error) => this.userFeedback.displayError(error));

        return this._loadingPromise;
    }
    get error() {
        return this.getError();
    }
    getError() {
        return this._glueError;
    }
    set error(glueError) {
        return this.setError(glueError);
    }
    setError(glueError) {
        let prevError = this.getError();
        this._glueError = glueError;

        this.emit("ErrorOcurred", this.getError(), prevError);
        return this;
    }
    get loading() {
        return this.getLoading();
    }
    getLoading() {
        return this._loadingPromise;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /* Start PUBLIC API ACTION METHODS */
    /*******************************************/
    expandAll() {
        this.emit("ExpandAll");
    }
    collapseAll() {
        this.emit("CollapseAll");
    }
    launchEditor(editorState, editorName, opts) {
        this._editorLayout.launchEditor(editorState, Registrations.PACKAGE_EDITOR, opts);
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
}
PackageExplorerLmrbComponent.$inject = [
    "$teve.userSession",
    "$teve.logger",
    "EditorLayout.EditorLayout",
    "$teve.services.Hubby",
    "$teve.ui.userFeedback",
    "$teve.magicBus",
    "$teve.solutionsManager",
    "$teve.io",
    "$teve.di",
];
PackageExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
PackageExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
PackageExplorerLmrbComponent.$iconRepoName = "slnman.packageExplorer";
PackageExplorerLmrbComponent.$openedByDefault = true;
PackageExplorerLmrbComponent.$displayName = "Package Explorer";
module.exports = PackageExplorerLmrbComponent;
